import React, { Fragment, useState } from 'react';

import { Stack } from '@chakra-ui/react';

import { useCmsData } from '../../../../hooks/use-cms-data';
import { useSettings } from '../../../../hooks/use-settings';
import { Url } from '../../../../misc/enums';
import { createId } from '../../../../misc/utilities';
import { BackButton, NavigationMobileItem } from '../NavigationMobileItem/NavigationMobileItem';

const NAV_ITEMS = [
	{
		name: 'Digitalisierung',
		to: `/${Url.DIGITALIZATION}/`,
		active: false,
	},
	{
		name: 'Kurse',
		to: `/${Url.COURSES}/`,
		active: false,
	},
	{
		name: 'Über uns',
		to: `/${Url.ABOUT}/`,
		active: false,
		position: 'right',
	},
	{
		name: 'Referenzen',
		to: `/${Url.REFERENCES}/`,
		active: false,
		position: 'right',
	},
	{
		name: 'Kontakt',
		to: `/${Url.CONTACT}/`,
		active: false,
		position: 'right',
	},
	{
		name: 'Warenkorb',
		to: `/${Url.CART}/`,
		active: false,
		position: 'right',
	},
];

const ulBaseStyle = {
	spacing: 0,
	w: '100%',
	position: 'absolute',
	top: 0,
};

export const NavigationMobileItems = () => {
	const { digitalizationPages, courseTypes } = useCmsData();
	const { digitalizationOrder, coursesOrder } = useSettings();

	const [baseEls, setBaseEls] = useState(() =>
		NAV_ITEMS.map((item) => {
			// level 1
			const modifiedItem = {
				id: item.name,
				title: item.navigationTitle ?? item.name,
				to: item.to,
			};
			if (item.name === 'Kurse') {
				modifiedItem.active = false;
				modifiedItem.sub = coursesOrder.entries.map((courseOrderEntry) => {
					const courseType = courseTypes.find(
						({ node: courseType }) => courseType.frontmatter.uuid === courseOrderEntry.courseType,
					).node;

					// level 2
					return {
						id: courseType.id,
						title: courseType.frontmatter.title,
						to: `${item.to}${courseType.frontmatter.slug}/`,
					};
				});
			} else if (item.name === 'Digitalisierung') {
				modifiedItem.active = false;
				modifiedItem.sub = digitalizationOrder.entries.map((digitalizationOrderEntry) => {
					const digitalizationPage = digitalizationPages.find(
						({ node: { frontmatter: digitalizationPage } }) =>
							digitalizationPage.uuid === digitalizationOrderEntry.digitalizationParent,
					).node;

					// level 2
					return {
						id: digitalizationPage.id,
						title:
							digitalizationPage.frontmatter.navigationTitle ??
							digitalizationPage.frontmatter.title,
						to: `${item.to}${digitalizationPage.frontmatter.slug}/`,
					};
				});
			}
			return modifiedItem;
		}),
	);

	// https://stackoverflow.com/a/15523704
	const findItemById = (object, id) => {
		if (object.hasOwnProperty('id') && object['id'] === id) return object;

		for (let i = 0; i < Object.keys(object).length; i++) {
			if (typeof object[Object.keys(object)[i]] == 'object') {
				let o = findItemById(object[Object.keys(object)[i]], id);
				if (o != null) return o;
			}
		}

		return null;
	};

	const setActive = (id) => {
		const updatedBaseEls = [...baseEls];
		findItemById(updatedBaseEls, id).active = true;
		setBaseEls(updatedBaseEls);
	};

	const setInactive = (id) => {
		const updatedBaseEls = [...baseEls];
		findItemById(updatedBaseEls, id).active = false;
		setBaseEls(updatedBaseEls);
	};

	const hasActiveItem = () => baseEls.filter((item) => item.active).length > 0;

	const hasActiveSubItem = (item) => {
		if (!item.sub) return false;
		return item.sub.filter((subitem) => subitem.active).length > 0;
	};

	return (
		<Stack as="ul" {...ulBaseStyle} left={hasActiveItem() ? '-100%' : '0'}>
			{baseEls.map((item) => (
				<NavigationMobileItem key={item.id} handleClick={() => setActive(item.id)} {...item}>
					{item.sub && (
						<Fragment>
							{item.active && (
								<Stack
									as="ul"
									id={`nav-${createId(item.to)}`}
									aria-labelledby={createId(item.to)}
									{...ulBaseStyle}
									left={item.active && !hasActiveSubItem(item) ? '100%' : '0'}
								>
									<BackButton handleClick={() => setInactive(item.id)}>{item.title}</BackButton>
									{item.sub.map((subItem) => (
										<NavigationMobileItem
											key={subItem.id}
											handleClick={() => setActive(subItem.id)}
											{...subItem}
										>
											{subItem.sub && subItem.active && (
												<Stack
													as="ul"
													id={`nav-${createId(item.to)}`}
													aria-labelledby={createId(item.to)}
													{...ulBaseStyle}
													left={subItem.active ? '100%' : '0'}
												>
													<BackButton handleClick={() => setInactive(subItem.id)}>
														{subItem.title}
													</BackButton>
													{subItem.sub.map((subSubItem) => (
														<NavigationMobileItem
															key={subSubItem.id}
															handleClick={() => setActive(subSubItem.id)}
															{...subSubItem}
														/>
													))}
												</Stack>
											)}
										</NavigationMobileItem>
									))}
								</Stack>
							)}
						</Fragment>
					)}
				</NavigationMobileItem>
			))}
		</Stack>
	);
};
